import React from 'react';
import {
    Datagrid,
    FunctionField,
    List,
    TextField,
    TextInput,
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import { ResourceListTitle } from '../AdminResourceTotalCount';

const filters = [
    <TextInput
        key="all"
        source="all"
        label="Recherche"
        alwaysOn
    />,
];

const valueOrDash = (value: any) =>
    value === null || value === undefined || value === ''
        ? '—'
        : value;

export const LoyaltyProspectList = (props: any) => (
    <List
        {...props}
        filters={filters}
        perPage={50}
        pagination={<AdminPagination />}
        bulkActionButtons={false}
        sort={{ field: 'last_seen_at', order: 'DESC' }}
        title={
            <ResourceListTitle
                resource="loyaltyadmin"
                label="Prospects Box Boukan"
            />
        }
    >
        <Datagrid rowStyle={() => ({ whiteSpace: 'nowrap' })}>
            <FunctionField
                label="Téléphone"
                render={(record: any) =>
                    valueOrDash(record.telephone)
                }
            />

            <TextField
                source="registration_count"
                label="Inscriptions"
            />

            <TextField
                source="distinct_event_count"
                label="Événements"
            />

            <FunctionField
                label="Code promo"
                render={(record: any) =>
                    valueOrDash(record.promo_code)
                }
            />

            <FunctionField
                label="État code"
                render={(record: any) =>
                    ({ active: 'Actif', redeemed: 'Utilisé', expired: 'Expiré', cancelled: 'Annulé' } as any)[record.promo_status] || '—'
                }
            />

            <FunctionField
                label="SMS"
                render={(record: any) =>
                    ({ pending: 'En attente', submitted: 'Envoyé', delivered: 'Livré', rejected: 'Rejeté', failed: 'Échec' } as any)[record.sms_status] || '—'
                }
            />

            <FunctionField
                label="Brevo"
                render={(record: any) => {
                    const labels: any = {
                        synchronized: 'Enregistré',
                        error: 'Erreur',
                    };
                    return labels[record.brevo_status] || 'Non enregistré';
                }}
            />

            <FunctionField
                label="Contrôle Brevo"
                render={(record: any) =>
                    record.brevo_checked_at
                        ? new Date(record.brevo_checked_at).toLocaleString('fr-FR')
                        : '—'
                }
            />

            <FunctionField
                label="Compte"
                render={(record: any) =>
                    record.user_id
                        ? record.user_email || 'Compte lié'
                        : 'Non lié'
                }
            />

            <FunctionField
                label="Mailchimp"
                render={(record: any) => {
                    const labels: any = {
                        synchronized: 'Synchronisé',
                        absent: 'Absent',
                        unsubscribed: 'Désabonné',
                        cleaned: 'Nettoyé',
                        error: 'Erreur',
                    };
                    return labels[record.mailchimp_status] || '—';
                }}
            />

            <FunctionField
                label="Contrôle Mailchimp"
                render={(record: any) =>
                    record.mailchimp_checked_at
                        ? new Date(record.mailchimp_checked_at).toLocaleString('fr-FR')
                        : '—'
                }
            />

            <FunctionField
                label="Code utilisé"
                render={(record: any) =>
                    record.conversion_status === 'converted'
                        ? 'Oui'
                        : 'Non'
                }
            />
        </Datagrid>
    </List>
);

export default LoyaltyProspectList;
